import { SectionAuth } from '@/features/auth/components';
import { isTokenValid } from '@/utils/token';
import { Navigate } from 'react-router-dom';

export const Auth = () => {
  if (isTokenValid()) {
    return <Navigate to="/" replace />;
  }
  return (
    <div className="relative h-screen w-screen overflow-hidden bg-[url(/src/assets/images/auth-bg-image.png)] bg-cover bg-center p-6">
      <div className="flex h-full items-center justify-center">
        <SectionAuth />
      </div>
    </div>
  );
};
